import { useState } from 'react'
import { Form } from 'react-bootstrap';

import { ButtonV1, Image } from 'lib';
import Check from "assets/images/validation_checkmark.svg"
import "./index.scss"
import LoginPage from 'components/LoginPage';

const list = [
    {
        label: "At least 8 characters",
    },
    {
        label: "Numbers",
    },
    {
        label: "Uppercase Characters",
    },
    {
        label: "Lowercase Characters",
    },
    {
        label: "Special characters excluding \ , . ~ < and >",
    },
]

const SetPassword = () => {

    const [form, setForm] = useState({});
    const [errors, setErrors] = useState({})

    const setField = (field, value) => {
        setForm({ ...form, [field]: value })

        if (!!errors[field]) {
            setErrors({ ...errors, [field]: null })
        }
    }

    const validateForm = () => {
        const { password, confirm_password } = form;
        const newErrors = {}

        if (!confirm_password || confirm_password === '') newErrors.confirm_password = "Enter correct password"
        if (!password || password === '') newErrors.password = "Enter a valid password"

        return newErrors
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const formErrors = validateForm()
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
        } else {
            // console.log("Form submitted", form)
        }
    }

    return (
        <LoginPage>
            <div className='setpassword_container'>
                <Form>
                    <p>Set Password</p>
                    <Form.Group controlId='password'>
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" className="form-input" placeholder='Enter password' onChange={e => setField('password', e.target.value)} value={form.password} isInvalid={!!errors.password}></Form.Control>
                        <Form.Control.Feedback type='invalid'>{errors.password}</Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId='confirm_passsword'>
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control type="password" className="form-input" placeholder='Enter confirm password' onChange={e => setField('confirm_password', e.target.value)} value={form.confirm_password} isInvalid={!!errors.confirm_password}></Form.Control>
                        <Form.Control.Feedback type='invalid'>{errors.confirm_password}</Form.Control.Feedback>
                    </Form.Group>
                    <div className='password_criteria'>
                        <ul className='list'>
                            {list.map(item => {
                                return (
                                    <>
                                        <li className=''><Image imageSrc={Check} className="checkmark" />{item.label}</li>
                                    </>
                                )
                            })}
                        </ul>
                    </div>
                    <ButtonV1 label="Proceed" className="login_button" />
                </Form>
            </div>
        </LoginPage>
    )
}

export default SetPassword